module.exports = __webpack_public_path__ + "98f67a6ff36afda7a5ec44ec59eb5033.svg";